import { FloatingCallAction, FloatingCallVideo, FloatingCallAudio } from '../../../../assets/images';
import './FloatingCallOption.scss';
import PropTypes from 'prop-types';

const FloatingCallOption = (props = {}) => {
    const { handleAudioCall, handleVideoCall } = props;
    return (
        <label className="FloatingCallAction" htmlFor="FloatingAction">
            <input id="FloatingAction" type="checkbox" />
            <span>
                <FloatingCallAction />
            </span>
            <ul>
                <li
                    title="Video call"
                    onClick={handleVideoCall || null}
                    onKeyDown={e => {
                        if (handleVideoCall && (e.key === 'Enter' || e.key === ' ')) {
                            handleVideoCall();
                        }
                    }}
                    role="button"
                    tabIndex="0"
                >
                    <i>
                        <FloatingCallVideo />
                    </i>
                </li>
                <li
                    title="Audio call"
                    onClick={handleAudioCall || null}
                    onKeyDown={e => {
                        if (handleAudioCall && (e.key === 'Enter' || e.key === ' ')) {
                            handleAudioCall();
                        }
                    }}
                    role="button"
                    tabIndex="0"
                >
                    <i>
                        <FloatingCallAudio />
                    </i>
                </li>
            </ul>
        </label>
    );
};

export default FloatingCallOption;

FloatingCallOption.propTypes = {
    handleAudioCall: PropTypes.func,
    handleVideoCall: PropTypes.func,
};
